/* eslint-disable no-console */
import { createStore, applyMiddleware /* compose, */ } from 'redux';

export default (reducers, middlewares) => {
  const enhancer = applyMiddleware(...middlewares);

  return createStore(reducers, enhancer);
};
